import React, { Component } from "react";
import { Pencil, Trash2 } from "lucide-react";
import { Toast } from "primereact/toast";
import { Comments } from "../../models/Comments";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Loader from "../../components/Loader";

interface ViewCommentsState {
    isLoading: boolean;
    comments: Comments[];
}

export default class UserCommentsComponent extends Component<unknown, ViewCommentsState> {
    toast: Toast | null = null;

    constructor(props: any | Readonly<any>) {
        super(props);

        this.state = {
            isLoading: false,
            comments: [],
        };
    }

    actionBodyTemplate(rowData: any) {
        return (
            <div className="flex items-center gap-1">
                <button
                    type="button"
                    className="p-1.5 rounded-md text-neutral-400 hover:text-primary-600 hover:bg-primary-50 dark:hover:text-primary-400 dark:hover:bg-primary-900/20 transition-colors"
                    title="Edit"
                >
                    <Pencil size={15} />
                </button>
                <button
                    type="button"
                    className="p-1.5 rounded-md text-neutral-400 hover:text-danger-600 hover:bg-danger-50 dark:hover:text-danger-400 dark:hover:bg-danger-900/20 transition-colors"
                    title="Delete"
                >
                    <Trash2 size={15} />
                </button>
            </div>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <>
                    <Toast ref={(el) => (this.toast = el)} />
                    <Loader />
                </>
            );
        }

        return (
            <div>
                <h4 className="text-sm font-semibold text-neutral-700 dark:text-neutral-300 px-5 pt-4 pb-2">Comments</h4>
                    <Toast ref={(el) => (this.toast = el)} />
                    <DataTable value={this.state.comments} emptyMessage="No Comments available">
                        <Column field="text" header="Comment Text"></Column>
                        <Column body={this.actionBodyTemplate}></Column>
                    </DataTable>
            </div>
        );
    }
}
